<script lang="ts" setup>
  import { inject, ref } from "vue";
  import type { VueCookies } from "vue-cookies";
  import { useSessionStore } from "@/stores/session";

  const sessionStore = useSessionStore();
  const cookies = inject<VueCookies>('$cookies')!;

  const COOKIE_NAME = 'changeit_cookies_consent';
  const cookieValue = cookies.get(COOKIE_NAME);
  sessionStore.cookiesAccepted = !!cookieValue && cookieValue === 'true';

  const showCookiePanel = ref<boolean>(!cookieValue);

  function confirm(value: boolean) {
    cookies.set(COOKIE_NAME, value, '1y');
    sessionStore.cookiesAccepted = value;
    showCookiePanel.value = false;
  }

</script>

<template>
  <v-snackbar
    :model-value="showCookiePanel"
    color="#F4F7FE"
    :timeout="-1"
  >
    <div class="title">
      <span>{{ $t('home.cookies.title') }}</span>
    </div>
    <div class="content">
      <div class="sub-title">
        {{ $t('home.cookies.subtitle') }}
      </div>
      <div class="buttons">
        <v-btn
          rounded="sm"
          variant="outlined"
          @click="confirm(false)"
          target="_blank"
          size="large"
        >
          {{ $t('home.cookies.reject') }}
        </v-btn>
        <v-btn
          rounded="sm"
          @click="confirm(true)"
          target="_blank"
          size="large"
        >
          {{ $t('home.cookies.accept') }}
        </v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<style lang="scss" scoped>
  :deep(.v-snackbar__wrapper) {
    border-color: rgb(var(--v-theme-neutral-200));
    min-width: 350px;
    max-width: none;
    width: min(90%, 1078px);
  }

  :deep(.v-snackbar__content) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1.5rem;
    border: 1px solid rgb(var(--v-theme-neutral-200));
    border-radius: 0.5rem;
    color: rgb(var(--v-theme-neutral-400));
  }

  .title {
    font-weight: 700;
    font-size: 18px;
  }

  .content {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .buttons {
      display: flex;
      align-items: center;
      gap: 1.5rem;
    }
  }

  @media screen and (max-width: breakpoint(md) - 1px) {
    .content {
      flex-direction: column;

      .buttons {
        gap: 0.5rem;
        flex-direction: column;
        width: 100%;

        :deep(button) {
          width: 100%;
        }
      }
    }
  }
</style>
